import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';
import Slider from 'react-slick';
import styles from 'pages/podcasts/[podcast-name]/PodcastList.module.scss';

const MyEpisode = ({ data, loadingStatus }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1124,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 810,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  };

  useEffect(() => {
    if (window !== undefined) {
      document?.querySelectorAll('.ellipsify')?.forEach((e) => {
        if (e.offsetWidth < e.scrollWidth) {
          e.setAttribute('title', e.textContent);
        } else {
          e.removeAttribute('title');
        }
      });
    }
  }, []);

  const renderSpinner = () => <Spinner animation="grow" />;

  const renderPodcasts = () => (
    <div className={styles.singleRow}>
      <Slider {...settings}>
        {data &&
          data?.map((item) => (
            <div className={`${styles.singleCol} mb-4 ml-3 mr-3`} key={item.id}>
              <a
                href={item?.redirect_url}
                data-type={item?.type}
                className={styles.singleGrid}>
                <div
                  className={styles.cover}
                  style={{
                    backgroundImage: `url('${item?.cover_webp}')`,
                    aspectRatio: '1',
                  }}></div>
              </a>
              <a href={item?.redirect_url}>
                <p className={`ellipsify ${styles.episodeTitle}`}>
                  {item?.name}
                </p>
              </a>
              <a href={item?.audio_redirect_url}>
                <p className={`ellipsify ${styles.podcastTitle}`}>
                  {item?.audio_name}
                </p>
              </a>
            </div>
          ))}
      </Slider>
    </div>
  );

  if (loadingStatus) return renderSpinner();
  return renderPodcasts();
};

MyEpisode.propTypes = {
  data: PropTypes.array.isRequired,
  loadingStatus: PropTypes.bool.isRequired,
};

export default MyEpisode;
